/* global angular*/
(function(){
	'use strict';
	angular.module('hhv.migration', ['hhv.db'])
		.run(['$rootScope', '$http', 'HvItem', function($rootScope, $http, HvItem){
			var rocketPunchOrgs = {};
			var migrationService ={
				migrateOrgs: migrateOrgs,
				loadRocketPunchLocations: loadRocketPunchLocations,
				loadRocketPunchCompanies: loadRocketPunchCompanies,
				loadRocketPunch: loadRocketPunch,
				saveRocketPunch: saveRocketPunch
			};

			$rootScope.migrationService = migrationService;

			function migrateOrgs(orgs){
				for(var i in orgs){
					var org = orgs[i];
					var item = new HvItem(org);
					var tagObjs = item.tags;
					item.tags = [];
					item.name_en = item.nameen;
					item.address_detail = item.address;
					item.latitude = item.lat;
					item.longitude = item.lng;
					item.logo = item.logourl;
					for(var tagKey in tagObjs){
						item.tags.push(tagObjs[tagKey].name);
					}
					if(!item.name){
						console.error(item, org);
						continue;rs
					}
					item.$save();
				}
			}


			function loadRocketPunchLocations(){
				return $http.get('/db/locations.json')
					.then(function(response){
						var data = response.data;
						for (var i = data.length - 1; i >= 0; i--) {
							var org = data[i];
							org.id = 'R'+org.id;
							if(!rocketPunchOrgs[org.id]){
								rocketPunchOrgs[org.id] = org;
							}
						}
					});
			}

			function loadRocketPunchCompanies(){
				return $http.get('/db/companies_utf.json')
					.then(function(response){
						var data = response.data;
						for (var i = data.length - 1; i >= 0; i--) {
							var org = data[i];
							org.id = 'R'+org.id;
							if(rocketPunchOrgs[org.id]){
								org.slug = org.id;
								org.brief = org.overview;
								org.logourl = org.logo;
								org.website = org.homepage;
								delete org.overview;
								delete org.logo;
								delete org.homepage;
								angular.extend(rocketPunchOrgs[org.id], org);	
								//$scope.organizations.push(org);
							}
						}
					});
			}

			function loadRocketPunch(){
				return loadRocketPunchLocations().then(loadRocketPunchCompanies).then(function(data){
					console.log(rocketPunchOrgs);
				});
			}

			function saveRocketPunch(){
				return loadRocketPunch().then(function(){
					migrateOrgs(rocketPunchOrgs);
				});
			}

		}]);
})(angular);